import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <path
      clipRule="evenodd"
      d="M22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12ZM20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12C4 9.87827 4.84285 7.84344 6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1571 7.84344 20 9.87827 20 12Z"
      fillRule="evenodd"
    />
    <path d="M12 13.6899C12.4661 13.6899 12.7373 13.3809 12.7458 12.8026L12.8729 8.00698C12.8898 7.41874 12.5169 7 11.9915 7C11.4661 7 11.1017 7.40877 11.1186 7.99701L11.2373 12.8126C11.2542 13.3809 11.5254 13.6899 12 13.6899ZM12 17C12.5508 17 13 16.5314 13 15.9033C13 15.2652 12.5593 14.8066 12 14.8066C11.4492 14.8066 11 15.2752 11 15.9033C11 16.5314 11.4576 17 12 17Z" />
  </>,
  'Exclamation',
)
